import orderBy from 'lodash/orderBy';
import { DateUtils } from '@vectord/utils';

import getUTCMinuteOfDay from './getUTCMinuteOfDay';
import toStartOfUTCDay from './toStartOfUTCDay';

const DAYS = DateUtils.DAY_FULL_NAMES.map((day) => day.toLowerCase());

function getDatesForSchedule({
  holidays = [],
  dayTimes,
  start = new Date(),
  end = null,
  maxDates = 100,
}) {
  const orderedDayTimes = orderBy(
    dayTimes,
    [
      (dayTime) => {
        return DAYS.indexOf(dayTime.day.toLowerCase());
      },
      'minute_of_day',
    ],
    ['asc', 'asc']
  );

  const scheduleDates = [];
  let currentDate = start;
  let index = 0;
  const holidayDates = holidays.map((holiday) =>
    new Date(holiday.date).toDateString()
  );
  while (
    (end && currentDate <= end) ||
    scheduleDates.length <= maxDates + holidayDates.length
  ) {
    const dayTime = orderedDayTimes[index];

    const currentDay = currentDate.getUTCDay();
    const currentMinute = getUTCMinuteOfDay(currentDate);
    const scheduleDay = DAYS.indexOf(dayTime.day.toLowerCase());
    const scheduleMinute = dayTime.minute_of_day;

    if (
      // If schedule day is in future
      scheduleDay > currentDay ||
      // If schedule day is same as today but time is in future
      (scheduleDay === currentDay && scheduleMinute > currentMinute)
    ) {
      const scheduleDate = new Date(currentDate);

      const date = scheduleDate.getUTCDate() + scheduleDay - currentDay;
      const hour = Math.floor(scheduleMinute / 60);
      const minute = Math.floor(scheduleMinute % 60);

      scheduleDate.setUTCDate(date);
      scheduleDate.setUTCHours(hour);
      scheduleDate.setUTCMinutes(minute);
      scheduleDate.setUTCSeconds(0);
      scheduleDate.setUTCMilliseconds(0);

      scheduleDates.push(scheduleDate);

      currentDate = new Date(scheduleDate);

      // If max schedule day is also less than current date day then we
      // move the current date to next day.
    } else if (index === orderedDayTimes.length - 1) {
      currentDate = toStartOfUTCDay(
        currentDate.setUTCDate(currentDate.getUTCDate() + 1)
      );
    }

    index += 1;
    index %= orderedDayTimes.length;
  }
  const filteredDates = scheduleDates.filter(
    (scheduleDate) => !holidayDates.includes(scheduleDate.toDateString())
  );

  return filteredDates;
}

export default getDatesForSchedule;
